import React from 'react';
import AccountsManagementPage from './AccountsManagementComponents/AccountsManagementPage';

const AccountsManagementView = (props) => {
  return <AccountsManagementPage {...props} />;
};

export default AccountsManagementView;
